import { Box } from '@mui/material'
import CustomDialog from 'components/CustomDialog'
import SimpleBarScroll from 'components/SimpleBar'
import React from 'react'
import ValidationAssignment from './ValidationAssignmentToMachine'

const ValidationAssignmentDialog = ({ open, handleClose, machine }) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Manage validations"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <Box padding={2}>
            <ValidationAssignment machine={machine} fullGrid={false} />
          </Box>
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  )
}

export default ValidationAssignmentDialog